import { render, staticRenderFns } from "./CardSideMenu.vue?vue&type=template&id=1d6aa58d&"
import script from "./CardSideMenu.vue?vue&type=script&lang=js&"
export * from "./CardSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardSideMenu.vue"
export default component.exports